import React from 'react';
import SEO from '../components/SEO';
import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';

export default function Contact() {
  return (
    <>
      <SEO
        title="Fastlane ApS :: Kontakt"
        description="Kontakt Fastlane ApS på Storstrømsvej 42 i Esbjerg N. Telefon: +45 76 12 12 30, e-mail: booking@fastlane.dk. Professionel international shipping og spedition."
        canonicalUrl="https://fastlane.dk/kontakt"
      />

      <PageHeader
        title="Kontakt"
        subtitle="Vi sidder klar til at besvare dine spørgsmål og beregne et uforpligtende tilbud på din fragt."
        breadcrumbs={[{ label: 'Kontakt' }]}
      />

      <div className="py-12 sm:py-16 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12">
            {/* Left: Contact Info & Map Card */}
            <div className="lg:col-span-5 space-y-6">
              <div className="bg-white rounded-2xl shadow-sm border border-slate-200/90 p-6 sm:p-8 space-y-6">
                <div>
                  <h2 className="text-2xl font-bold text-[#0f2b48] mb-1">Fastlane ApS</h2>
                  <p className="text-xs uppercase font-bold tracking-wider text-sky-700">International Transport & Spedition</p>
                </div>

                <div className="space-y-4 text-sm text-slate-700">
                  <div className="flex items-start gap-3.5">
                    <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-700 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-location-dot" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Adresse</p>
                      <p className="text-slate-600">Storstroemsvej 42</p>
                      <p className="text-slate-600">6715 Esbjerg N</p>
                      <p className="text-slate-600">Denmark</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3.5">
                    <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-700 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-phone" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">Telefon</p>
                      <a
                        href="tel:+4576121230"
                        className="text-[#0f2b48] hover:text-sky-700 font-bold whitespace-nowrap transition-colors"
                      >
                        +45 76 12 12 30
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3.5">
                    <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-700 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-envelope" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">E-mail</p>
                      <a
                        href="mailto:booking@fastlane.dk"
                        className="text-sky-700 hover:text-sky-900 font-medium whitespace-nowrap transition-colors"
                      >
                        booking@fastlane.dk
                      </a>
                    </div>
                  </div>

                  <div className="flex items-center gap-3.5">
                    <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-700 flex items-center justify-center shrink-0">
                      <i className="fa-solid fa-building" aria-hidden="true" />
                    </div>
                    <div>
                      <p className="font-semibold text-slate-900">CVR Nummer</p>
                      <p className="text-slate-600 font-mono">DK 26 63 78 13</p>
                    </div>
                  </div>
                </div>

                {/* Bankoplysninger */}
                <div className="pt-6 border-t border-slate-100 space-y-2 text-xs text-slate-600">
                  <h4 className="font-bold text-slate-900 uppercase tracking-wider text-[11px]">Bankforbindelse</h4>
                  <p><strong className="text-slate-800">Bank:</strong> Sydjysk Sparekasse</p>
                  <p><strong className="text-slate-800">DKK Konto:</strong> <span className="font-mono">7686 0000564591</span></p>
                  <p><strong className="text-slate-800">BIC:</strong> <span className="font-mono">FROSDK21</span> | <strong className="text-slate-800">IBAN:</strong> <span className="font-mono">DK2876860000564591</span></p>
                  <p><strong className="text-slate-800">EURO Konto:</strong> <span className="font-mono">7686 3050568090</span></p>
                  <p><strong className="text-slate-800">BIC:</strong> <span className="font-mono">FROSDK21</span> | <strong className="text-slate-800">IBAN:</strong> <span className="font-mono">DK1776863050568090</span></p>
                </div>

                {/* Maps link */}
                <div className="pt-4 border-t border-slate-100">
                  <a
                    href="https://maps.google.com/?cid=11891933717599547968"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center w-full py-2.5 px-4 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-800 text-xs font-semibold transition-colors gap-2"
                  >
                    <i className="fa-solid fa-map-location-dot text-sky-700" aria-hidden="true" />
                    <span>Åbn i Google Maps / Rutevejledning</span>
                  </a>
                </div>
              </div>
            </div>

            {/* Right: Contact Form */}
            <div className="lg:col-span-7">
              <ContactForm
                title="Skriv til os via kontaktformularen"
                subtitle="Har du en opgave, et spørgsmål eller brug for rådgivning? Send os en besked her."
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
